import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";

//styled components
import themeHandler from "../helpers/themeHandler";
import { ThemeProvider } from "styled-components";
import GlobalStyle from "../styles/GlobalStyle";
// componentes de LOi
import Loading from "./Loading";
//provider
import { Provider } from "react-redux";
import store from "../redux/data";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { CategoriesLoadStoneSlider } from "./sliders/LoadStone";
//componentes
const ListadoGenericoDeProductos = React.lazy(() =>
  import("./listas/ListadoGenericoDeProductos/ListadoGenericoDeProductos")
);

let container = document.getElementById("listado-generico-placeholder");
const root = createRoot(container);

const queryClient = new QueryClient();

container &&
  root.render(
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={themeHandler(window.location.hostname)}>
        <GlobalStyle />
        <Suspense fallback={<Loading />}>
          <ListadoGenericoDeProductos />
          <CategoriesLoadStoneSlider />
        </Suspense>
      </ThemeProvider>
      </QueryClientProvider>
    </Provider>
  );
